import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import Seo from '../../../../components/Misc/Seo';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/vale-preop/Vale Pre-Op_Slider.jpg';
import projectImage2 from '../../../../assets/images/work/vale-preop/Vale Pre-Op_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/vale-preop/Vale Pre-Op_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/vale-preop/Vale Pre-Op_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/vale-preop/Vale Pre-Op_Slider_5.jpg';
import projectImage6 from '../../../../assets/images/work/vale-preop/Vale Pre-Op_Slider_6.jpg';

import Data_ValePreOp from './Data_ValePreOp';

function Work_ValePreOp() {
    const canonical = 'https://studio.norcat.org/OurWork/vale-preop';
    const title = 'Vale Pre-Op | Studio NORCAT - Driven by experiences that matter.';
    const description = 'Developed by Studio NORCAT, Vale Pre-Op is a VR training experience that helps operators build safer pre-operational inspection habits and confident equipment checks before work begins.';

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={`${window.location.origin}${projectImage1}`}
                ogImageAlt="Preview of the Vale Pre-Op VR training project"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={`${window.location.origin}${projectImage1}`}
                twitterImageAlt="Preview of the Vale Pre-Op VR training project"
            />
            <DetailedHeader
                heading="Building Safer Habits Before the First Turn"
                client="Vale Canada"
                service="Virtual Reality"
                date="2021"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                useButtonNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=G1HxJJAI-Os"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Vale Pre-Op project screenshot 1',
                    },
                    {
                        image: projectImage2,
                        alt: 'Vale Pre-Op project screenshot 2',
                    },
                    {
                        image: projectImage3,
                        alt: 'Vale Pre-Op project screenshot 3',
                    },
                    {
                        image: projectImage4,
                        alt: 'Vale Pre-Op project screenshot 4',
                    },
                    {
                        image: projectImage5,
                        alt: 'Vale Pre-Op project screenshot 5',
                    },
                    {
                        image: projectImage6,
                        alt: 'Vale Pre-Op project screenshot 6',
                    },
                ]}
            />

            {Data_ValePreOp.content}
        </>
    );
}

export default Work_ValePreOp;
